import React from "react";
import { motion } from "motion/react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

const ACTIVE_PILL_LAYOUT_ID = "navbar-capsule-active-pill";

const pillTransition = {
  type: "spring",
  stiffness: 420,
  damping: 34,
  mass: 0.65,
};

/** @param {string} text */
export const navLinkTestId = (text) => {
  const slug = String(text || "")
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return `navbar-${slug || "link"}-link`;
};

/**
 * Capsule-style nav link: inactive = muted text; active = blue pill + white label.
 * The active pill slides horizontally when changing route (shared layoutId).
 * @param {string} text
 * @param {string} url
 * @param {string} [dataTestId]
 */
const NavBarButton = ({ text, url, "data-testid": dataTestId }) => {
  const { pathname } = useLocation();
  const isActive =
    pathname === url || (url !== "/" && pathname.startsWith(url));

  return (
    <Link
      to={url}
      data-testid={dataTestId || navLinkTestId(text)}
      className={cn(
        "relative shrink-0 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium outline-none transition-colors focus-visible:ring-2 focus-visible:ring-[#1976d2]/40 focus-visible:ring-offset-2 focus-visible:ring-offset-[#eceff1]",
        isActive ? "text-white" : "text-[#546e7a] hover:text-[#37474f]"
      )}
    >
      {isActive ? (
        <motion.span
          layoutId={ACTIVE_PILL_LAYOUT_ID}
          className="absolute inset-0 z-0 rounded-full bg-[#1976d2]"
          transition={pillTransition}
        />
      ) : null}
      <span className="relative z-10">{text}</span>
    </Link>
  );
};

export default NavBarButton;
